import React from 'react';

// You might need to add useState to your imports in this file if it's not there
import { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Box,
  Typography, CircularProgress, Grid, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper
} from '@mui/material';

const PurchaseRequisitionPopup = ({ open, onClose, data, onSubmit }) => {
  // We keep the isSubmitting state within the popup itself
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!onSubmit || !data) return;
    setIsSubmitting(true);
    try {
      await onSubmit(data);
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatLabel = (key) => key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

  // Helper to render the content based on data type
  const renderContent = () => {
    if (!data) {
      return <Typography color="text.secondary">No data available.</Typography>;
    }

    // Case 1: Data is an array of items (the new format)
    if (Array.isArray(data)) {
      const headers = Object.keys(data[0] || {});
      return (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead sx={{ backgroundColor: (theme) => theme.palette.action.hover }}>
              <TableRow>
                {headers.map(key => <TableCell key={key} sx={{ fontWeight: 'bold', color: 'text.primary' }}>{formatLabel(key)}</TableCell>)}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, index) => (
                <TableRow key={index}>
                  {headers.map(key => <TableCell key={key}>{item[key]}</TableCell>)}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    // Case 2: Data is a single object (the old format)
    if (typeof data === 'object' && data !== null) {
      return (
        <Grid container spacing={2}>
          {Object.entries(data).map(([key, value]) => (
            <Grid item xs={12} sm={6} key={key}>
              <Typography component="div">
                <Box component="span" sx={{ fontWeight: 'bold' }}>{formatLabel(key)}:</Box> {String(value)}
              </Typography>
            </Grid>
          ))}
        </Grid>
      );
    }

    return <Typography color="text.secondary">Invalid data format.</Typography>;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Confirm Purchase Requisition</DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6" gutterBottom>Please review and confirm the details below:</Typography>
        <Box sx={{ mt: 2, p: 1 }}>
          {renderContent()}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" disabled={isSubmitting || !data}>
          {isSubmitting ? <CircularProgress size={24} /> : 'Create PR'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PurchaseRequisitionPopup;